// import socketIOClient from 'socket.io-client';

import AnimationController from './controllers/animation';
import PageController from './controllers/page';
import RoutingController from './controllers/routing';
import SectionController from './controllers/section';
import SessionController from './controllers/session';


class App {

	states = {
		isInitiated: false,
		isIframe: false
	};

	el = {};

	socket;

	page = null;

	constructor() {
		this.states.isIframe = window.location.pathname.includes('styleguide/iframe');

		// this.socket = socketIOClient('https://app-socket.basicagencydev.com', { secure: true });
		// console.log(this.socket);

		this.addEventListeners();
	}

	gatherElements() {
		this.el = {
			main: document.querySelector('main')
		};
	}

	configureControllers() {
		PageController.container = this.el.main;

		SectionController.container = this.el.main;
		SectionController.initializeGlobals();

		AnimationController.start();

		RoutingController.overrideAnchors();
		RoutingController.start({
			'/': () => this.open('projects'),
			'/:page': (page) => this.open(page)
			// '/:id/:a/?:b': (id, a, b) => console.log(id, a, b)
		});
	}

	// TODO awaits!
	async open(slug) {
		this.page = slug;
		if (!this.statesisInitialized) {
			this.statesisInitialized = true;
			PageController.detect();
			SessionController.checkSession()
				.then((data) => {
					SectionController.updateGlobal('header', { page: slug, username: data.user.firstname });
					if (slug !== PageController.active) {
						PageController.close();
						PageController.open(slug);
					}
				})
				.catch(() => {
					PageController.close();
					PageController.open('login');
				});
		} else {
			window.scrollTo(0, 0);
			SectionController.destroy(PageController.active);
			PageController.close();
			SessionController.checkSession()
				.then((data) => {
					PageController.open(slug);
					SectionController.updateGlobal('header', { page: slug, username: data.user.firstname });
				})
				.catch(() => {
					PageController.close();
					PageController.open('login');
				});
		}
	}

	apply(slug) {
		RoutingController.overrideAnchors();
		SectionController.initialize(slug);
	}

	continue() {
		PageController.close();
		this.open(this.page);
	}

	#onDOMContentLoaded = () => {
		if (!this.states.isIframe) {
			this.gatherElements();
			this.configureControllers();
		}
	};

	addEventListeners() {
		document.addEventListener('DOMContentLoaded', this.#onDOMContentLoaded);
	}

}

export default new App();
